module.exports = __webpack_public_path__ + "assets/img/sabc_social_linkedin.webp?9c9b417d9f3b8923abdaf71e16c2ad0b";